import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
// import striptags from 'striptags';
import Select from "../../../components/form/select/Select";
import PageTitle from "../../../components/partials/PageTitle";
import {
  getSingleClause,
  resetUpdatedStatus,
  updateClause,
} from "../../../redux/slice/clauses/clauseSlice";
import * as Yup from "yup";
import { getAllActivePolicies, getAllActiveSavingsPolicies } from "../../../redux/slice/policy/policySlice";
import RichTextEditor from "../../../components/form/RichTextEditor";
import Loading from "../../../components/loader/Loading";
import { policyCategories } from "../../../utils/data/constant";

const PreloadedClauseDetail = () => {
  const [hasEditClause, setHasEditClause] = useState();
  const [updateLoader, setUpdateLoader] = useState(false);
  const { user } = useSelector((state) => state.auth?.user);
  const [editing, setEditing] = useState(false);
  const { active_policy } = useSelector((state) => state.policy);
  const { isLoading, clause_info, isUpdated, isUpdating, isSuccess } =
    useSelector((state) => state.clause);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const [policyData, setPolicyData] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const policySelectRef = useRef();
  const {id} = useParams();
  const {state} = useLocation();

  const breadcrumb = {
    from: {
      title: "Preloaded clauses",
      link: clause_info?.policy_category === '1' ? "/admin/settings/preloaded-clauses" : "/admin/settings/preloaded-savings-clauses",
    },
    current: {
      title: "view clause",
      link: null,
    },
  };

  const handleClose = () => {
    values.clause_name = clause_info?.clause_name;
    values.description = clause_info?.description;
    values.policy_id = clause_info?.policy_id;
  };

  const policyCat = policyCategories?.map((cat, index) => ({
    label: cat.title,
    value: index + 1,
  }));

  const onSubmit = (values) => {
    const payload = { ...values, id: clause_info?.id };
    dispatch(updateClause(payload));
  };

  const validationScehma = Yup.object().shape({
    clause_name: Yup.string("Clause Title must be a string").required(
      "Clause Title cannot be blank"
    ),
    policy_id: Yup.number("Policy Id must be a number").required(
      "Policy is required"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      clause_name: clause_info?.clause_name || "",
      description: clause_info?.description || "",
      policy_id: clause_info?.policy_id || "",
      policy_category: clause_info?.policy_category || "",
    },
    validationSchema: validationScehma,
    onSubmit,
    validate: (values) => {
      const errors = {};

      if (!values.description.trim()) {
        errors.description = "description is required";
      } else if (!hasEmptyTags(values.description)) {
        errors.description = "Description cannot be empty";
      }

      return errors;
    },
  });

  const hasEmptyTags = (content) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/g;
    return regex.test(content);
  };

  // const plainTextContent = striptags(clause_info?.description)

  useEffect(() => {
    const policyData = active_policy?.policy
      ?.filter((item) => item.policy_cat_id === String(values.policy_category))
      .map((policy) => {
        return {
          label: policy.name,
          value: policy.id,
        };
      });

    setPolicyData(policyData);
    setFieldValue("policy_id", "");
    policySelectRef?.current?.clearValue();
  }, [values.policy_category]);

  useEffect(() => {
    if (values.policy_category === 1) {
      dispatch(getAllActivePolicies({ office_id: parseInt(user?.office_id) }));
    }
    if (values.policy_category === 2) {
      dispatch(
        getAllActiveSavingsPolicies({ office_id: parseInt(user?.office_id) })
      );
    }
  }, [values.policy_category, user?.office_id, dispatch]);

  useEffect(() => {
    dispatch(getSingleClause({id, policy_category: state.category}));

    if (isSuccess) {
      setUpdateLoader(false);
    }
  }, [dispatch, id, isSuccess, state.category]);

  useEffect(() => {
    if (isUpdating) {
      setUpdateLoader(true);
    }
    if (isUpdated) {
      dispatch(getSingleClause(id));
      setEditing(false);
      dispatch(resetUpdatedStatus());
    }
  }, [dispatch, id, isUpdated, isUpdating]);

  const handleContentChange = (newContent) => {
    setFieldValue("description", newContent, true);
  };

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "settings module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "clause module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "view clause details"
      )
    ) {
      navigate("/admin/dashboard");
    }

    setHasEditClause(
      user_permissions?.some((permission) => permission.name === "edit clause")
    );
  }, [navigate, user_permissions]);

  if (isLoading && !updateLoader) {
    return (
      <div className='mt-3'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Preloaded Clauses' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12 position-relative'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary '>
                    {editing ? "Edit Clause" : "Clause Details"}
                  </h4>
                  <span
                    onClick={() => navigate(-1)}
                    className='btn btn-primary btn-sm float-end '
                  >
                    Go Back
                  </span>
                </div>
              </div>
              <form className='row' onSubmit={handleSubmit}>
                <div className='col-md-9'>
                  {/* Clause Title */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='staff_id' className='col-form-label'>
                        Clause Title
                      </label>
                    </div>
                    <div class='col-sm-6'>
                      {!editing ? (
                        <p className='form-control border-0 shadow'>
                          {clause_info?.clause_name}{" "}
                        </p>
                      ) : (
                        <div>
                          <input
                            type='text'
                            className='form-control form-control-sm'
                            id='clause_name'
                            value={values?.clause_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors?.clause_name && touched?.clause_name && (
                            <p className='mb-0 text-danger'>
                              {errors?.clause_name + "*"}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Policy Target */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='first_name' className='col-form-label'>
                        Policy Category
                      </label>
                    </div>
                    <div class='col-sm-6'>
                      {!editing ? (
                        <p className='form-control border-0 shadow'>
                          {
                            policyCat?.filter(
                              (item) =>
                                String(item.value) ===
                                clause_info?.policy_category
                            )[0]?.label
                          }
                        </p>
                      ) : (
                        <div>
                          <Select
                            onBlur={() => {
                              handleBlur({
                                target: { name: "policy_category" },
                              });
                            }}
                            name='policy_category'
                            data={policyCat}
                            value={parseInt(values?.policy_category)}
                            onChange={(selectedOption) =>
                              setFieldValue(
                                "policy_category",
                                selectedOption?.value
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Policy Target */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='first_name' className='col-form-label'>
                        Policy Target
                      </label>
                    </div>
                    <div class='col-sm-6'>
                      {!editing ? (
                        <p className='form-control border-0 shadow'>
                          {clause_info?.policy_name}
                        </p>
                      ) : (
                        <div>
                          <Select
                            onBlur={() => {
                              handleBlur({ target: { name: "policy_id" } });
                            }}
                            name='policy_id'
                            data={policyData}
                            value={parseInt(values?.policy_id)}
                            onChange={(selectedOption) =>
                              setFieldValue("policy_id", selectedOption?.value)
                            }
                            ref={policySelectRef}
                          />
                          {errors?.policy_id &&
                            touched?.policy_id &&
                            !values.policy_id && (
                              <p className='mb-0 text-danger'>
                                {errors?.policy_id + "*"}
                              </p>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Last Name */}
                  <div className='row mb-4'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='last_name' className='col-form-label'>
                        Description
                      </label>
                    </div>
                    <div className='col-sm-8'>
                      {!editing ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: clause_info?.description,
                          }}
                          className='border-0 shadow p-1 form-control'
                        />
                      ) : (
                        <div>
                          <RichTextEditor
                            name='description'
                            id='description'
                            onBlur={() => {
                              handleBlur({ target: { name: "description" } });
                            }}
                            value={values.description}
                            onChange={handleContentChange}
                          />
                          {errors?.description && touched?.description && (
                            <p
                              className='mb-0 text-danger'
                              style={{ marginTop: "40px" }}
                            >
                              {errors?.description + "*"}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-1'></div>
                  {hasEditClause && (
                    <div className='col-sm-2 d-flex gap-1'>
                      <button
                        type='button'
                        className={`btn btn-${
                          editing ? "warning" : "info"
                        } btn-sm mt-3 px-4 text-white`}
                        onClick={() => {
                          setEditing(editing ? false : true);
                          handleClose();
                        }}
                      >
                        {editing ? "Close" : "Edit"}
                      </button>
                      {editing && (
                        <button
                          className='btn btn-primary ms-2 btn-sm mt-3 px-4'
                          type='submit'
                        >
                          Update
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
          {isUpdating && <Loading />}
        </div>
      </div>
    </>
  );
};

export default PreloadedClauseDetail;
